const KEYS = {
  teams: "teamId"
}

export default KEYS;
